export const generateRequestProps = (id?: string) => ({
  refetchOnMountOrArgChange: true,
  skip: !id || ['null', 'undefined'].includes(id),
});
